import { DEFAULT_LOCALE } from '@/constants';

type Messages = Record<string, string>;
type Translations = Record<string, Messages>;

const translationLoaders = import.meta.glob<Messages>('./*.json', { import: 'default' });

const getLocaleFromPath = (path: string) => path.replace(/^\.\//u, '').replace(/\.json$/u, '');

// Like the translations file served by the translation service before the migration, this
// provides the messages of ALL locales. The user can change the language at runtime and the
// matching messages have to be available without reloading the page.
const loadTranslations = async (): Promise<Translations> => {
    const entries = await Promise.all(
        Object.entries(translationLoaders).map(async ([path, load]) => {
            const locale = getLocaleFromPath(path);

            try {
                return [locale, await load()] as const;
            } catch (error) {
                if (locale === DEFAULT_LOCALE) {
                    throw error;
                }

                console.warn(`Translations for "${locale}" could not be loaded. Falling back to "${DEFAULT_LOCALE}".`);
                return null;
            }
        })
    );

    return Object.fromEntries(entries.filter(entry => entry !== null));
};

export default loadTranslations;
